export default __webpack_public_path__ + "static/media/warning--divided-highway-ends--g1.236372f1.png";